<template>
  <div class="box safe-distance-top-header">
    <Header :pageTitle="''" :shareInfo="shareInfo" />
    <div class="detail-box">
      <div class="baseinfo-box">
        <div class="logo-box">
          <img
            class="cover"
            :src="
              coverImg
                ? $global.imgUrl + coverImg
                : userInfo.coverImg
                ? $global.imgUrl + userInfo.coverImg
                : require('@/assets/img/mobile-img/image_error_ic.webp')
            "
            alt=""
          />
          <div class="name-box">
            <h2>{{ userInfo.name }}</h2>
            <p v-show="userInfo.englishName">{{ userInfo.englishName }}</p>
            <div v-show="userInfo.cn" class="name-cn">
              CN：{{ userInfo.cn }}
            </div>
            <div v-show="userInfo.issn" class="name-cn">
              ISSN：{{ userInfo.issn }}
            </div>
          </div>
        </div>
      </div>
      <div class="tabs-box">
        <van-tabs
          v-model="tabActive"
          class="tab-box"
          :ellipsis="false"
          color="#4a79f1"
          title-active-color="#4a79f1"
          title-inactive-color="#333"
        >
          <van-tab title="简介" name="0">
            <div class="tabs-info" v-for="item in introList" :key="item.key">
              <div class="info-lab">{{ item.label }}</div>
              <div
                class="info-content"
                v-if="
                  item.key === 'responsibleDeptList' ||
                  item.key === 'organizerList' ||
                  item.key === 'publishCompanyList'
                "
              >
                <p
                  v-for="unitItem in userInfo[item.key]"
                  :key="unitItem.orgId"
                  @click="toMlDetail(unitItem.orgId)"
                >
                  {{ unitItem.orgName }}
                </p>
              </div>
              <div
                class="info-content"
                v-else-if="item.key === 'publishPeriod'"
              >
                {{ cycleList[userInfo[item.key]] }}
              </div>
              <div
                class="info-content"
                v-else-if="item.key === 'periodicalIntro'"
                v-html="userInfo[item.key]"
              ></div>
              <div
                class="info-content"
                v-else-if="item.key === 'publishAddrProvince'"
              >
                {{ userInfo[item.key] }} - {{ userInfo.publishAddrCity }}
              </div>
              <div class="info-content" v-else>{{ userInfo[item.key] }}</div>
            </div>
          </van-tab>
          <van-tab title="论文" name="1">
            <BkLvList :argumentObj="lvArgumentObj" :listRequest="getLvList" @onBkLvListChange="handleIssueChange">
            </BkLvList>
          </van-tab>
          <van-tab title="编委会" name="9">
            <EditorialList
              :argumentObj="lvArgumentObj"
              :listRequest="getLvList"
            />
          </van-tab>
          <van-tab title="期刊简介" name="10">
            <div
                class="info-content"
                v-html="userInfo.periodicalIntro"
              ></div>
          </van-tab>
          <van-tab title="征稿启事" name="2">
            <div class="html-box" v-html="userInfo.notice"></div>
          </van-tab>
          <van-tab title="资讯" name="3" v-if="hasZx">
            <DetailList
              listType="5"
              :argumentObj="zxArgumentObj"
              :listRequest="getZxList"
            />
          </van-tab>
          <!-- <van-tab title="专著" name="4">
            <DetailList
              listType="2"
              :argumentObj="paramsObj"
              :listRequest="getZzList"
            />
          </van-tab> -->
          <van-tab title="会议" name="5" v-if="partnerTabs[10]">
            <DetailList
              listType="8"
              :argumentObj="hyArgumentObj"
              :listRequest="getHyList"
            />
          </van-tab>
          <van-tab title="课程" name="6" v-if="partnerTabs[11]">
            <DetailList
              listType="9"
              :argumentObj="paramsObj"
              :listRequest="getKcList"
            />
          </van-tab>
          <van-tab title="商品" name="7" v-if="partnerTabs[9]">
            <DetailList
              listType="11"
              :argumentObj="paramsObj"
              :listRequest="getTsList"
            />
          </van-tab>
          <van-tab title="行业报告" name="8" v-if="partnerTabs[12]">
            <DetailList
              listType="12"
              :argumentObj="paramsObj"
              :listRequest="getBgList"
            />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/detailHeader.vue";
import BkLvList from "./components/bkLvList.vue";
import DetailList from "./components/detailList.vue";
import EditorialList from "./components/editorialList.vue";
export default {
  components: {
    Header,
    DetailList,
    EditorialList,
    BkLvList,
  },
  data() {
    return {
      tabActive: "1",
      userInfo: {}, //学者基本信息
      cycleList: {
        1: "年刊",
        2: "半年刊",
        3: "季刊",
        4: "双月刊",
        5: "月刊",
        6: "半月刊",
        7: "旬刊",
        8: "周刊",
        9: "周二刊",
      }, // 出版周期
      introLabelList: [
        {
          label: "期刊名称",
          key: "name",
        },
        {
          label: "外文名称",
          key: "englishName",
        },
        {
          label: "主管单位",
          key: "responsibleDeptList",
        },
        {
          label: "主办单位",
          key: "organizerList",
        },
        {
          label: "出版单位",
          key: "publishCompanyList",
        },
        {
          label: "出版周期",
          key: "publishPeriod",
        },
        {
          label: "ISSN",
          key: "issn",
        },
        {
          label: "CN",
          key: "cn",
        },
        {
          label: "出版地",
          key: "publishAddrProvince",
        },
        {
          label: "语种",
          key: "language",
        },
        {
          label: "开本",
          key: "format",
        },
        {
          label: "邮发代号",
          key: "codeDomestic",
        },
        {
          label: "创刊时间",
          key: "foundedDate",
        },
        {
          label: "学科分类",
          key: "subject",
        },
        {
          label: "收录数据库",
          key: "coreName",
        },
        {
          label: "简介",
          key: "signature",
        },
      ], // 简介展示内容结构
      introList: [], // 简介实际展示内容
      // 论文列表参数
      lvArgumentObj: {
        id: this.$route.query.id,
        userType: this.$route.query.item,
        articleType: 0,
      },
      // 资讯列表参数
      zxArgumentObj: {
        id: this.$route.query.id,
        userType: this.$route.query.item,
      },
      // 会议列表参数
      hyArgumentObj: {
        companyId: this.$route.query.id,
        userType: this.$route.query.item,
      },
      // 专著,课程,图书,报告(商品列表参数)
      paramsObj: {
        companyId: this.$route.query.id,
      },
      shareInfo: {},
      hasZx: false,
      partnerTabs: {
        9: false,
        10: false,
        11: false,
        12: false,
      },
      coverImg: "",
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.tabActive = this.$route.query.tab;
    }
    this.getDetailInfo();
    this.getPartnerList();
    this.getUserTabs();
    this.getCoverImg();
  },
  methods: {
    handleIssueChange(i) {
      this.coverImg = i.cover ?? this.defaultCoverImg;
    },
    async getCoverImg() {
      const res = await this.$apis.hundredServe.getLatestPeriodical(
        this.$route.query.id
      );
      if (res.data && res.data.cover) {
        this.coverImg = res.data.cover;
        this.defaultCoverImg = res.data.cover;
      }
    },
    async getUserTabs() {
      // userTabs: 0-论文，1-资讯，2-专著
      const { resultCode, data } =
        await this.$apis.hundredServe.getUserDetailTabs({
          userType: 1,
          id: this.$route.query.id,
        });
      if (resultCode === "200") this.hasZx = data[1];
    },
    async getPartnerList() {
      // content: 9-图书 10-会议 11-课程 12-行业报告 有key就代表tab展示
      const { resultCode, content } =
        await this.$apis.hundredServe.getPartnerDetailTabs({
          userType: "PERIODICAL",
          companyId: this.$route.query.id,
        });
      if (resultCode === "200") {
        for (const key in this.partnerTabs) {
          this.partnerTabs[key] = Object.keys(content).some(
            (item) => item == key
          );
        }
      }
    },
    // 跳转名录详情页
    toMlDetail(orgId) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesinstitutions",
        query: {
          type: 2,
          orgId,
          out,
        },
      });
    },
    // 获取用户信息
    async getDetailInfo() {
      const res = await this.$apis.recomendServe.periodical({
        id: this.$route.query.id,
      });
      if (res.resultCode === "200") {
        this.userInfo = res.content.periodicalInfo;
        console.log(this.userInfo)
        this.introList = this.introLabelList.filter((item) => {
          if (this.userInfo[item.key] && this.userInfo[item.key] !== "[]") {
            return {
              key: item.key,
              label: item.label,
              value: this.userInfo[item.key],
            };
          }
        });
        this.shareInfo = {
          title: this.userInfo.name,
          artSummary: this.userInfo.periodicalIntro,
          cover: this.userInfo.coverImg,
          articleId: this.$route.query.id,
          userType: this.$route.query.item,
        };
      } else {
        console.log(res);
      }
    },
    // 获取论文列表
    async getLvList(params) {
      let res = await this.$apis.hundredServe.getMobileSyncThesisList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取资讯列表
    async getZxList(params) {
      let res = await this.$apis.hundredServe.getBlogList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取会议列表
    async getHyList(params) {
      let res = await this.$apis.hundredServe.getMeetingList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取专著列表
    async getZzList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilZzList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list.map((item) => ({
            articleType: 2,
            articleId: item.id,
            ...item,
          })),
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取课程列表
    async getKcList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilKcList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取商品(图书)列表
    async getTsList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilTsList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.data ? res.data.data : [],
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取行业报告列表
    async getBgList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilBgList({
        ...params,
        type: 4,
      });
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.data ? res.data.data : [],
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding-top: 56px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  .detail-box {
    padding: 0 12px;
    .baseinfo-box {
      margin-bottom: 12px;
      padding: 16px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      .logo-box {
        display: flex;
        .cover {
          margin-right: 24px;
          width: 100px;
          height: 140px;
        }
        .name-box {
          flex: 1;
          h2 {
            margin-bottom: 23px;
            font-size: 16px;
            color: #333333;
            line-height: 24px;
          }
          p {
            margin-bottom: 24px;
            font-size: 13px;
            font-weight: 500;
            color: #494949;
            line-height: 20px;
          }
          .name-cn {
            font-size: 13px;
            color: #999999;
            line-height: 24px;
          }
        }
        // justify-content: center;
      }
    }
    .tabs-box {
      margin-bottom: 12px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .tab-box {
        &::v-deep .van-tabs__wrap {
          .van-tabs__nav {
            padding-left: 0;
            padding-right: 0;
            .van-tab__text {
              font-size: 15px;
            }
            .van-tab--active {
              .van-tab__text {
                font-weight: 700;
              }
            }
          }
        }
        &::v-deep .van-tabs__content {
          padding: 16px;
        }
        .tabs-info {
          display: flex;
          margin-bottom: 15px;
          font-size: 14px;
          color: #333333;
          line-height: 24px;
          .info-lab {
            margin-right: 38px;
            width: 70px;
            flex: none;
          }
          .info-content {
            max-width: 200px;
            &::v-deep img,
            &::v-deep video {
              width: 100% !important;
              height: 100% !important;
            }
            &::v-deep span {
              white-space: normal !important;
            }
          }
        }
      }
    }
  }
  .html-box {
    &::v-deep img,
    &::v-deep video {
      width: 100% !important;
      height: 100% !important;
    }
    &::v-deep span {
      white-space: normal !important;
    }
  }
}
</style>
